import React from "react";
import { Button, Tooltip } from "@mui/material";

export default function ActionButton(props) {
  const { color, children, onClick, disabled, title = "add" } = props;

  const getButtonStyles = (theme) => ({
    minWidth: 0,
    margin: theme.spacing(0.5),
    ...(color === "secondary" && {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
      "&:hover": {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
      },
    }),
    ...(color === "primary" && {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
      },
    }),
  });

  return (
    <Tooltip title={title} aria-label="add">
      <Button
        disabled={disabled}
        sx={getButtonStyles}
        onClick={onClick}
      >
        {children}
      </Button>
    </Tooltip>
  );
}